import { createAction } from 'redux-actions';

// saga
export const GLOBAL_INIT = 'saga/global/init';
export const INIT_NAV_MENU = 'global/saga/initNavMenu';

export const GET_CONFIG_DICTS = 'dsp/config/dicts';
export const getConfigDictsAction = createAction(GET_CONFIG_DICTS);

export const GET_PEAR_CONFIG_DICTS = 'dsp/pear/config/dicts';
export const getPearConfigDictsAction = createAction(GET_PEAR_CONFIG_DICTS);

export const GET_AD_ACCOUNT_INFO = 'dsp/ad_account/info';

// reducer
export const UPDATE_USER_INFO = 'global/updateUserInfo';
export const UPDATE_USER_ROLE = 'global/updateUserRole';
export const UPDATE_MENU = 'global/updateMenu';
export const UPDATE_AUTHORITY = 'global/updateAuthTree';
export const UPDATE_PERMISSION = 'global/updatePermission';
export const UPDATE_FUND_IDS = 'global/updateFundIds';

export const UPDATE_CONFIG_DICTS = 'global/updateConfigDicts';
export const UPDATE_PEAR_CONFIG_DICTS = 'global/updatePearConfigDicts';

export const UPDATE_AD_ACCOUNT_INFO = 'global/updateAdAccountInfo';
export const UPDATE_ADVERTISER_DETAIL = 'global/updateadAccountInfo';
export const UPDATE_HEADER_BADGE_COUNT = 'global/updateHeaderBadgeCount';
export const UPDATE_HEADER_MSG = 'global/updateHeaderMsg';
export const UPDATE_CENTER_MSG = 'global/updateCenterMsg';
export const UPDATE_TARGET_CONTROL = 'global/updateTargetControl';

export const USR_LOGIN_SUCCESS = 'usrLoginSuccess';
export const USR_LOGOUT_SUCCESS = 'useLogoutSuccess';
export const UPDATE_CURRENCY = 'global/updateCurrency';
export const UPDATE_CURRENCY_CONFIG = 'global/updateCurrencyConfig';
export const UPDATE_TIMEZONE = 'global/updateTimezone';

// 公共模块
export const UPDATE_COMMON_SPINNING = 'global/common/spinning';
export const UPDATE_COMMON_ONLY_SPINNING = 'global/common/onlySpinning';
export const UPDATE_COMMON_DELAY_EVENTS = 'global/common/delayEvents';

// 广告投放模块
export const UPDATE_ADVERT_FORM_STEP = 'global/advert/updateFormStep';
export const UPDATE_ADVERT_SKAN = 'global/advert/updateSkan';
export const UPDATE_ADVERT_CONFIRM_PRE = 'global/advert/updateConfirmPre';
